import Session from '@/components/Session';

import Icon_11 from '@/assets/images/icon_11.svg';
import Icon_12 from '@/assets/images/icon_12.svg';
import Icon_13 from '@/assets/images/icon_13.svg';
import Icon_14 from '@/assets/images/icon_14.svg';
import Icon_15 from '@/assets/images/icon_15.svg';
import Icon_16 from '@/assets/images/icon_16.svg';

export default function Why({ detail }) {
    return (
        <>
            <Session className='why'>
                <div className='title'>{detail?.label?.why?.title || 'Why Choose Us?'}</div>
                <div className='items'>
                    <div className='item'>
                        <img
                            className='bg'
                            src='data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=='
                        />
                        <div className='box'>
                            <img
                                className='icon'
                                src={Icon_11.src}
                            />
                            <div className='name'>
                                <span>{detail?.label?.why?.items?.[0] || 'Move-in Ready'}</span>
                            </div>
                        </div>
                    </div>

                    <div className='item'>
                        <img
                            className='bg'
                            src='data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=='
                        />
                        <div className='box'>
                            <img
                                className='icon'
                                src={Icon_12.src}
                            />
                            <div className='name'>
                                <span>{detail?.label?.why?.items?.[1] || 'All-inclusive Price'}</span>
                            </div>
                        </div>
                    </div>

                    <div className='item'>
                        <img
                            className='bg'
                            src='data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=='
                        />
                        <div className='box'>
                            <img
                                className='icon'
                                src={Icon_13.src}
                            />
                            <div className='name'>
                                <span>{detail?.label?.why?.items?.[2] || 'Free Housekeeping'}</span>
                            </div>
                        </div>
                    </div>

                    <div className='item'>
                        <img
                            className='bg'
                            src='data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=='
                        />
                        <div className='box'>
                            <img
                                className='icon'
                                src={Icon_14.src}
                            />
                            <div className='name'>
                                <span>{detail?.label?.why?.items?.[3] || 'Additional Services & Perks'}</span>
                            </div>
                        </div>
                    </div>

                    <div className='item'>
                        <img
                            className='bg'
                            src='data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=='
                        />
                        <div className='box'>
                            <img
                                className='icon'
                                src={Icon_15.src}
                            />
                            <div className='name'>
                                <span>{detail?.label?.why?.items?.[4] || 'Residential Security'}</span>
                            </div>
                        </div>
                    </div>

                    <div className='item'>
                        <img
                            className='bg'
                            src='data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=='
                        />
                        <div className='box'>
                            <img
                                className='icon'
                                src={Icon_16.src}
                            />
                            <div className='name'>
                                <span>{detail?.label?.why?.items?.[5] || 'Access to Hotel Facilities'}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </Session>
        </>
    );
}
